export const EurekaAmountsControlApi = Symbol.for('EurekaAmountsControlApi');

/**
 * Eureka 权益菜单控制字段。
 */
export interface EurekaAmountsControl {
    /**
     * 是否展示 AI 工作站入口。
     */
    ai_agent_studio?: boolean;
    /**
     * 是否展示项目入口。
     */
    work_project?: boolean;
    /**
     * 是否展示知识库入口。
     */
    vault_permission?: boolean;
    /**
     * 是否展示积分入口，包含 active Credits 或有 Credits 历史的场景。
     */
    credit_package?: boolean;
    /**
     * 是否展示计次套餐入口。
     */
    count_package?: boolean;
    /**
     * 是否为免费用户。
     */
    freemium?: boolean;
}

/**
 * Eureka 权益控制 API。
 */
export interface EurekaAmountsControlApi {
    /**
     * 获取 Eureka 权益菜单控制配置。
     */
    getAmountsControl(): Promise<EurekaAmountsControl>;
}
